import { useAuth } from "react-oidc-context";

export function Login() {
  const auth = useAuth();
  return (
    <div className="flex min-h-full items-center justify-center px-6">
      <div className="w-full max-w-sm rounded-2xl border border-slate-800 bg-slate-900 p-8 shadow-xl">
        <h1 className="text-2xl font-semibold text-accent">JobHunter</h1>
        <p className="mt-2 text-sm text-slate-400">
          Sign in to coordinate ingest, scoring, and review of your tailored job applications.
        </p>
        <button
          type="button"
          className="mt-6 w-full rounded-md bg-accent px-4 py-2 font-medium text-accent-fg transition hover:opacity-90"
          onClick={() => auth.signinRedirect()}
        >
          Sign in
        </button>
      </div>
    </div>
  );
}
